import { formatImageUrl } from "@/lib/utils";
import LeaderBoardListingCard from "./listing-card";

type LeaderBoardListingProps = {
	users: {
		id: string;
		name: string | null;
		image: string | null;
		UserProfile: {
			location: string | null;
			company: string | null;
			howDoYouIdentifyYourself: string | null;
			isVerified: boolean | null;
			isFounder: boolean | null;
			username: string;
		} | null;
		CategoryLeader: {
			userType: string;
		}[];
		isAmbassador: boolean;
	}[];
};

const LeaderBoardListing = ({ users }: LeaderBoardListingProps) => {
	return (
		<div className="max-w-6xl mx-auto">
			<div className="grid items-start justify-center grid-cols-2 mt-8 mb-16 gap-x-8 gap-y-12 md:grid-cols-4 lg:grid-cols-6">
				{users.map((user) => (
					<LeaderBoardListingCard
						key={user.id}
						name={user.name || ""}
						howDoYouIdentifyYourself={user.UserProfile?.howDoYouIdentifyYourself || ""}
						company={user.UserProfile?.company || ""}
						location={user.UserProfile?.location || ""}
						image={formatImageUrl(user.image) || ""}
						isVerified={user.UserProfile?.isVerified || false}
						isFounder={user.UserProfile?.isFounder || false}
						isAmbassador={user.isAmbassador || false}
						username={user.UserProfile?.username || ""} />
				))}
			</div>
		</div>
	);
};

export default LeaderBoardListing;
